import React, { useCallback, useEffect, useState } from 'react'
import {
  Button, CircularProgress, Card, CardContent, Typography, Grid,
} from '@material-ui/core'
import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'
import { enqueueSnackbar } from 'store/modules/notifications'
import { getTitulosResgataveis, criarResgate } from 'store/modules/api/resgates-lbc/resgates-lbc.api'
import ResgatarModal from './resgatar-modal'

const TitulosResgataveis = ({ unidades = [], anoSelecionado, refetch }) => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const [titulos, setTitulos] = useState([])
  const [loading, setLoading] = useState(true)
  const [sel, setSel] = useState(null)

  const carregar = useCallback(async () => {
    setLoading(true)
    try { setTitulos(await getTitulosResgataveis()) } finally { setLoading(false) }
  }, [])
  useEffect(() => { carregar() }, [carregar])

  const confirmar = async ({ anoBase, quantidade, unidadeId }) => {
    try {
      await criarResgate({
        tituloLbcId: sel.id, anoBase, quantidade, unidadeId,
      })
      setSel(null)
      dispatch(enqueueSnackbar({ message: t('resgatesLbc.resgateOk'), options: { variant: 'success', autoHideDuration: 3000 } }))
      await carregar()
      refetch?.()
    } catch (e) {
      dispatch(enqueueSnackbar({ message: e.message, options: { variant: 'warning', autoHideDuration: 4000 } }))
    }
  }

  if (loading) return <CircularProgress />
  return (
    <>
      <Grid container spacing={2}>
        {titulos.map((tit) => (
          <Grid item xs={12} md={6} key={tit.id}>
            <Card variant="outlined">
              <CardContent>
                <Typography variant="body2" style={{ fontFamily: 'monospace' }}>{tit.codigo}</Typography>
                <Typography variant="caption" color="textSecondary">
                  {t('resgatesLbc.ecorregiao')}: {tit.ecorregiao?.nome} · {t('resgatesLbc.disponivel')}: {Number(tit.quantidadeDisponivel).toLocaleString('pt-BR', { minimumFractionDigits: 2 })} LBC
                </Typography>
                <div style={{ marginTop: 10 }}>
                  <Button size="small" color="primary" variant="contained" onClick={() => setSel(tit)}>
                    {t('resgatesLbc.resgatar')}
                  </Button>
                </div>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
      {sel && (
        <ResgatarModal
          titulo={sel} unidades={unidades} anoBaseInicial={anoSelecionado}
          onFechar={() => setSel(null)} onConfirmar={confirmar}
        />
      )}
    </>
  )
}

export default TitulosResgataveis
